import {
  header as initialHeader,
  optionsMap as initialOptionsMap
} from './create-entry-summary'
import { esHeaderAbiFilersContact } from './user-settings'
import {
  paymentType,
  month,
  cargoReleaseProcessing,
  liveEntry,
  bondType,
  bondDesignationType,
  deferredTax,
  ftaReconciliation,
  otherReconciliation,
  consolidatedIndicator,
  shipmentUsage,
  continuousBondIndicator,
  missingDoc1,
  missingDoc2,
  pscHeaderReasonCode, yesNoOption
} from './options'
import { fetchPartyLookup } from './party-lookup'

const header = [
  {
    name: 'freightCharges',
    label: 'Freight Charges',
    type: 'number',
    maxLength: 10,
    placeholder: '',
    defaultValue: '1500',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'grossWeight',
    label: 'Gross Weight (Kgs)',
    type: 'number',
    maxLength: 10,
    placeholder: '',
    defaultValue: '16568',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'totalEntryValue',
    label: 'Total Entry Value',
    type: 'number',
    maxLength: 10,
    placeholder: '',
    defaultValue: '6081',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'merchandiseDesc',
    label: 'Description of Merchandise',
    type: 'textarea',
    maxLength: 1000,
    placeholder: '',
    defaultValue: 'IRON BED BEDSTEAD',
    required: true,
    disabled: false,
    icon: undefined
  },
  ...initialHeader,
  {
    name: 'estimatedEntryDate',
    label: 'Estimated Entry Date',
    type: 'date',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '2025-05-07',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'importDate',
    label: 'Date of Import',
    type: 'date',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '2025-05-07',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'itDate',
    label: 'I. T. Date',
    type: 'date',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'estimatedArrivalDate',
    label: 'Estimated Arrival Date',
    type: 'date',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '2025-05-07',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'processingPort',
    label: 'Processing Port',
    type: 'text',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '0901',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'statementDate',
    label: 'Statement Date',
    type: 'date',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '2025-05-19',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'paymentType',
    label: 'Payment Type',
    type: 'auto',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '6',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'periodicStatementMonth',
    label: 'Periodic Statement Month',
    type: 'auto',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'preparerPort',
    label: 'Preparer Port',
    type: 'text',
    maxLength: 4,
    placeholder: '',
    defaultValue: '2704',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'preparerOfficeCode',
    label: 'Preparer Office Code',
    type: 'text',
    maxLength: 10,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'preparerFilerCode',
    label: 'Preparer Filer Code',
    type: 'text',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'examPortCode',
    label: 'Exam Port Code',
    type: 'text',
    maxLength: 4,
    placeholder: '',
    defaultValue: '4601',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'brokerRefNo',
    label: 'Broker Reference No',
    type: 'text',
    maxLength: 9,
    placeholder: '',
    defaultValue: '0133113',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'cargoReleaseProcessing',
    label: 'Cargo Release Processing',
    type: 'auto description',
    maxLength: undefined,
    placeholder: '',
    defaultValue: 'Y',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'liveEntry',
    label: 'Live Entry',
    type: 'auto description',
    maxLength: undefined,
    placeholder: '',
    defaultValue: 'Y',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'examSite',
    label: 'Exam Site',
    type: 'text',
    maxLength: 4,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  }
]

const filer = esHeaderAbiFilersContact

const importer = [
  {
    name: 'importerOfRecordNumber',
    label: 'Importer of Record Number',
    type: 'auto description',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '32-043479200',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'ultimateConsigneeNumber',
    label: 'Ultimate Consignee Number',
    type: 'auto description',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '32-043412345',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'freightForwarder',
    label: 'Freight Forwarder',
    type: 'auto description',
    maxLength: undefined,
    placeholder: '',
    defaultValue: 'CRIMSONLOGIC (U.S.), INC.',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'designatedNotifyPartyNumber',
    label: 'Designated Notify Party Number',
    type: 'auto description',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  }
]

const bond = [
  {
    name: 'bondType',
    label: 'Bond Type',
    type: 'auto',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '9',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'bondDesignationType',
    label: 'Bond Designation Type',
    type: 'auto',
    maxLength: undefined,
    placeholder: '',
    defaultValue: 'B',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'continuousBondIndicator',
    label: 'Continuous Bond Indicator',
    type: 'auto',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'suretyCode',
    label: 'Surety Code',
    type: 'text',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'stbAmount',
    label: 'STB Amount',
    type: 'number',
    maxLength: 10,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    condition: (formData, sectionData) => sectionData?.bondType === '9'
  },
  {
    name: 'stbProducerAccountNo',
    label: 'STB Producer Account Number',
    type: 'text',
    maxLength: 10,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    condition: (formData, sectionData) => sectionData?.bondType === '9'
  }
]

/*
const bond1 = [];
const bond2 = [];
bond.forEach(field => {
  bond1.push({
    ...field,
    name: `bond1-${field.name}`,    
  });
  bond2.push({
    ...field,
    name: `bond2-${field.name}`,
  });
});
*/

const splitShipmentCode = [
  {
    name: 'splitShipmentCode',
    label: 'Split Shipment and/or non-AMS B/L',
    type: 'auto',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    sizeProp: { xs: 12, sm: 12, md: 8 }
  }
]

const miscellaneous = [
  {
    name: 'manualSurcharge',
    label: 'Manual Surcharge',
    type: 'number',
    maxLength: 8,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'informalFee',
    label: 'Informal Fee',
    type: 'number',
    maxLength: 8,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'dutiableMailFee',
    label: 'Dutiable Mail Fee',
    type: 'number',
    maxLength: 8,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'deferredTax',
    label: 'Deferred Tax',
    type: 'auto description',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'ftaReconciliation',
    label: 'FTA Reconciliation',
    type: 'auto description',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'otherReconciliation',
    label: 'Other Reconciliation',
    type: 'auto',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'consolidatedIndicator',
    label: 'Consolidated Indicator',
    type: 'auto description',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'shipmentUsage',
    label: 'Shipment Usage',
    type: 'auto',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'presentationDate',
    label: 'Presentation Date',
    type: 'date',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'arrivalDate',
    label: 'Arrival Date',
    type: 'date',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'weeklyEntryDate',
    label: 'Weekly Entry Date',
    type: 'date',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'consolidatedExpressFiling',
    label: 'Consolidated Express Filing',
    type: 'auto description',
    maxLength: undefined,
    placeholder: '',
    defaultValue: false,
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'disSubmittedIndicator',
    label: 'DIS Submitted Indicator',
    type: 'auto description',
    maxLength: undefined,
    placeholder: '',
    defaultValue: false,
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'missingDoc1',
    label: 'Missing Documents 1',
    type: 'auto',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'missingDoc2',
    label: 'Missing Documents 2',
    type: 'auto',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'postSummaryCorrection',
    label: 'Post Summary Correction',
    type: 'toggle',
    maxLength: undefined,
    placeholder: '',
    defaultValue: false,
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'requestAcceleratedLiquidation',
    label: 'Request Accelerated Liquidation',
    type: 'auto description',
    maxLength: undefined,
    placeholder: '',
    defaultValue: false,
    required: false,
    disabled: false,
    icon: undefined,
    condition: (formData) => formData?.header?.postSummaryCorrection === true
  },
  {
    name: 'originalEntryNumber',
    label: 'Original Entry Number',
    type: 'text',
    maxLength: 11,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    condition: (formData) => formData?.header?.postSummaryCorrection === true
  },
  {
    name: 'postSummaryCorrectionExplanation',
    label: 'Post Summary Correction Explanation',
    type: 'textarea',
    maxLength: 1000,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    condition: (formData) => formData?.header?.postSummaryCorrection === true
  },
  {
    type: 'new'
  },
  {
    name: 'generalOrderNumber',
    label: 'General Order Number',
    type: 'text',
    maxLength: 50,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
    {
    name: 'selfCertification',
    label: 'Self-Certification',
    type: 'auto description',
    maxLength: undefined,
    placeholder: '',
    defaultValue: false,
    required: false,
    disabled: false,
    icon: undefined
  },
]

const carrierDetails = [
  {
    name: 'carrierCode',
    label: 'Carrier Code',
    type: 'text',
    maxLength: 20,
    placeholder: '',
    defaultValue: '',
    required: true,
    disabled: false,
    icon: undefined
  },
  {
    name: 'voyage',
    label: 'Voyage',
    type: 'text',
    maxLength: 50,
    placeholder: '',
    defaultValue: '',
    required: true,
    disabled: false,
    icon: undefined
  },
  {
    name: 'dateOfArrival',
    label: 'Date of Arrival',
    type: 'date',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'carrierQuantity',
    label: 'Quantity',
    type: 'number',
    maxLength: 10,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'pipelineName',
    label: 'Pipeline Name',
    type: 'text',
    maxLength: 100,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  }
]

const additional = [
  {
    name: 'pscHeaderReasonCode',
    label: 'PSC Header Reason Code',
    type: 'auto',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: true, // When the add dialog is opened, does not make sense that this is not required cos user will just add a "blank" row
    disabled: false,
    icon: undefined
  }
]

const manifest = [
  {
    name: 'masterSCAC',
    label: 'Master SCAC',
    type: 'text',
    maxLength: 4,
    placeholder: '',
    defaultValue: 'MEDU',
    required: true,
    disabled: false,
    icon: undefined
  },
  {
    name: 'masterBill',
    label: 'Master Bill',
    type: 'text',
    maxLength: 50,
    placeholder: '',
    defaultValue: 'YY936880',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'houseSCAC',
    label: 'House SCAC',
    type: 'text',
    maxLength: 4,
    placeholder: '',
    defaultValue: 'DWCH',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'houseBill',
    label: 'House Bill',
    type: 'text',
    maxLength: 50,
    placeholder: '',
    defaultValue: 'SXMNS0019096',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'manifestQuantity',
    label: 'Quantity',
    type: 'number',
    maxLength: 10,
    placeholder: '',
    defaultValue: '646',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'manifestUnits',
    label: 'Units',
    type: 'text',
    maxLength: 10,
    placeholder: '',
    defaultValue: 'PKGS',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'containerNo',
    label: 'Container No.',
    type: 'text',
    maxLength: 20,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  }
]

const containers = [
  {
    name: 'containerNo',
    label: 'Container No.',
    type: 'text',
    maxLength: 20,
    placeholder: '',
    defaultValue: 'AMFU8873946',
    required: true, // When the add dialog is opened, does not make sense that this is not required cos user will just add a "blank" row
    disabled: false,
    icon: undefined
  },
  {
    name: 'weight',
    label: 'Weight (KG)',
    type: 'number',
    maxLength: 10,
    placeholder: '',
    defaultValue: '16568',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'containerQuantity',
    label: 'Quantity',
    type: 'number',
    maxLength: 10,
    placeholder: '',
    defaultValue: '646',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'containerUnits',
    label: 'Units',
    type: 'text',
    maxLength: 10,
    placeholder: '',
    defaultValue: 'PKGS',
    required: false,
    disabled: false,
    icon: undefined
  }
]

const print = [
  {
    name: 'brokerOrOtherGovtAgencyUse3461',
    label: '3461 Broker or Other Govt. Agency use',
    type: 'text',
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    sizeProp: { xs: 12, sm: 6, md: 6 }
  },
  {
    name: 'note7501',
    label: '7501 Note',
    type: 'text',
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    sizeProp: { xs: 12, sm: 6, md: 6 }
  }
]

const buildOptionsMap = async () => {
  const [
    importerOfRecordNumber,
    ultimateConsigneeNumber,
    freightForwarder,
    designatedNotifyPartyNumber
  ] = await Promise.all([
    fetchPartyLookup('IM', 'header'),
    fetchPartyLookup('CN', 'header'),
    fetchPartyLookup('FF', 'header'),
    fetchPartyLookup('DN', 'header')
  ])

  return {
    ...initialOptionsMap,
    paymentType: paymentType,
    periodicStatementMonth: month,
    cargoReleaseProcessing: cargoReleaseProcessing,
    liveEntry: liveEntry,
    bondType: bondType,
    bondDesignationType: bondDesignationType,
    continuousBondIndicator: continuousBondIndicator,
    /*
  'bond1-bondType': bondType,
  'bond1-bondDesignationType': bondDesignationType,
  'bond1-continuousBondIndicator': continuousBondIndicator,
  'bond2-bondType': bondType,
  'bond2-bondDesignationType': bondDesignationType,
  'bond2-continuousBondIndicator': continuousBondIndicator,
  */
    deferredTax: deferredTax,
    ftaReconciliation: ftaReconciliation,
    otherReconciliation: otherReconciliation,
    consolidatedIndicator: consolidatedIndicator,
    shipmentUsage: shipmentUsage,
        missingDoc1: missingDoc1,
    missingDoc2: missingDoc2,
    pscHeaderReasonCode: pscHeaderReasonCode,
                splitShipmentCode: [
      { description: 'Non-AMS Bill(s) of Lading', value: 'Y' },
      { description: 'Hold All - Release Entry when all cargo qualifies for release', value: '1' },
      { description: 'Request Special Permit to release cargo incrementally under Immediate Delivery procedures', value: '2' }
    ],
    importerOfRecordNumber: importerOfRecordNumber,
    ultimateConsigneeNumber: ultimateConsigneeNumber,
    freightForwarder: freightForwarder,
    designatedNotifyPartyNumber: designatedNotifyPartyNumber,
    consolidatedExpressFiling: yesNoOption,
    disSubmittedIndicator: yesNoOption,
    selfCertification: yesNoOption,
    requestAcceleratedLiquidation: yesNoOption,
  }
}

export {
  header,
  filer,
  importer,
  bond,
  /*
  bond1,
  bond2,
  */
  miscellaneous,
  splitShipmentCode,
  additional,
  carrierDetails,
  manifest,
  containers,
  print,
  buildOptionsMap
}
